exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg .error-close {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  color: #fff;\n  cursor: pointer;\n  font-weight: 600;\n}", ""]);

// exports
